import { render, staticRenderFns } from "./screen5.vue?vue&type=template&id=1989d1f6&scoped=true&"
import script from "./screen5.vue?vue&type=script&lang=js&"
export * from "./screen5.vue?vue&type=script&lang=js&"
import style0 from "./screen5.vue?vue&type=style&index=0&id=1989d1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1989d1f6",
  null
  
)

export default component.exports